import { useSyncExternalStore } from 'react';
import type { Session } from '../session/session';
import { getServerSession, getSession, subscribe } from '../session/session-store';

/** Re-renders whenever the stored session changes, including from another part of the app. */
export function useSession(): Session | null {
    return useSyncExternalStore(subscribe, getSession, getServerSession);
}
